import { makeStyles } from 'tss-react/mui';

export const useScrollableContainerStyles = makeStyles<string>()(
  (_theme, scrollWidth) => ({
    view: {
      paddingRight: scrollWidth,
    },
  }),
);
